@if (showChatButton()) {
  <button
    type="button"
    class="w-10 h-10 rounded-full bg-primary-500 text-white flex items-center justify-center hover:bg-primary-600 transition-colors disabled:bg-gray-700 disabled:hover:bg-gray-700"
    [attr.data-testid]="'chat-button-' + tender().tenderMappingId"
    [disabled]="chatDisabled() || !tender().activeChatParticipant"
    (click)="onOpenChat()"
  >
    <i class="pi pi-comment text-lg"></i>
  </button>
}
